import { render, staticRenderFns } from "./LabelSuggest.vue?vue&type=template&id=61e32244&"
import script from "./LabelSuggest.vue?vue&type=script&lang=js&"
export * from "./LabelSuggest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports